<!-- 企业级-用户管理-组织管理 -->
<template>
  <div class="mainArea COrganizeManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent" :class="{border: activeTab !== 'auth'}">
        <!-- 用户指引提示 -->
        <span class="tooltip" v-if="activeTab === 'department' && departmentData.list[0].children.length === 0">请点击此处进行添加部门的操作</span>

        <!-- 组织管理 -->
        <el-tabs class="tabList" v-model="activeTab" stretch>

          <!-- 用户 -->
          <el-tab-pane class="list user" label="用户" name="user">
            <!-- 内容左边区域 -->
            <div class="contentLeftArea">
              <!-- leftTopArea -->
              <div class="leftTopArea clearfix">
                <span class="text">部门名称</span>
              </div>
              <!-- 部门列表 -->
              <el-tree
                class="defineTree"
                v-loading="departmentData.loading"
                :data="departmentData.list"
                node-key="id"
                @node-click="treeNodeClick"
                default-expand-all
                :expand-on-click-node="false"
                :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <!-- 自定义icon -->
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span
                    class="label"
                    :class="data.id === userData.selected ? 'selected' : ''">{{ node.label }}</span>
                </span>
              </el-tree>
              <!-- 部门列表为空 -->
              <p class="contentNull" v-show="departmentData.list[0].children.length === 0">请点击部门结构旁边的添加按钮，或者在右边页面进行添加部门的操作</p>
            </div>

            <!-- 内容右边区域 -->
            <div class="contentRightArea clearfix">

              <!-- 搜索区域 -->
              <div class="searchArea clearfix">
                <el-input class="text" v-model="userData.paging.user_name" placeholder="请输入姓名" clearable></el-input>
                <el-input class="text" v-model="userData.paging.user_account" placeholder="请输入账号" clearable></el-input>
                <el-input class="text" v-model="userData.paging.phone_no" placeholder="请输入手机号" clearable></el-input>
                <el-button type="primary" class="serchBtn" @click="expShowMsg">搜索</el-button>
              </div>
              <!-- 按钮区域 -->
              <div class="btnArea">
                <el-button class="btn" @click="expShowMsg">添加</el-button>
                <el-button class="btn" @click="expShowMsg">批量导入</el-button>
              </div>

              <!-- 员工列表 -->
              <el-table
                v-loading="userData.loading"
                :data="userData.list"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  prop="user_name"
                  label="姓名">
                </el-table-column>
                <el-table-column
                  prop="user_account"
                  label="账号">
                </el-table-column>
                <el-table-column
                  prop="phone_no"
                  label="手机号码">
                </el-table-column>
                <el-table-column
                  prop="email"
                  label="邮箱">
                </el-table-column>
                <el-table-column
                  label="生物特征">
                   <template slot-scope="scope">
                    <el-button type="text" @click="operateDialogInfo('biometrics', scope.row)">查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="创建时间">
                </el-table-column>
                <el-table-column
                  prop="user_list"
                  label="状态" width="60">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialogInfo('changeUserStatus', scope.row)">{{scope.row.user_state === '1' ? '正常' : '禁用'}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作" width="90">
                  <template slot-scope="scope">
                    <el-button type="text" @click="operateDialogInfo('alterUser', scope.row)">修改</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页 -->
              <div class="paging" v-if="userData.pageCount > 1">
                <el-pagination
                  @current-change="userPageChange"
                  :current-page.sync="userData.paging.page"
                  layout="prev, pager, next, jumper"
                  :page-count="userData.pageCount">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>

          <!-- 部门 -->
          <el-tab-pane class="list" label="部门" name="department">
            <!-- 内容左边区域 -->
            <div class="contentLeftArea">
              <!-- leftTopArea -->
              <div class="leftTopArea clearfix">
                <span class="text">部门名称</span>
                <i class="icon el-icon-circle-plus-outline" @click="operateDialogInfo('addDepartment')"></i>
              </div>
              <!-- 部门列表 -->
              <el-tree
                class="defineTree"
                v-loading="departmentData.loading"
                :data="departmentData.list"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <!-- 自定义icon -->
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span
                    class="label"
                    :class="data.id === departmentData.selected ? 'selected' : ''"
                    @click="getDepartmentInfo(data.id)">{{ node.label }}</span>
                  <!-- 编辑、删除 -->
                  <span
                    class="operate"
                    v-show="node.level !== 1">
                    <span class="text" @click="operateDialogInfo('editDepartment', data, node)">编辑</span>
                    <span class="text" @click="operateDialogInfo('deleteDepartment', data, node)">删除</span>
                  </span>
                </span>
              </el-tree>
              <!-- 部门列表为空 -->
              <p class="contentNull" v-show="departmentData.list[0].children.length === 0">请点击部门结构旁边的添加按钮，或者在右边页面进行添加部门的操作</p>
            </div>

            <!-- 内容右边区域 -->
            <div class="contentRightArea clearfix">
              <p class="title">下级部门</p>
              <div class="updateWrapper">
                <ul class="updateBox clearfix" separator-class="el-icon-arrow-right">
                  <li class="item"
                    v-for="(item, index) in departmentData.departmentInfo.parent"
                    :key="index"
                    @click="getDepartmentInfo(item.id)">{{item.name}}</li>
                  <!-- 下级部门列表 -->
                  <ul class="listWrapper" :class="{hide: departmentData.departmentInfo.parent.length === 5}">
                    <li
                      class="list clearfix"
                      v-for="(cItem, cIndex) in departmentData.departmentInfo.children"
                      :key="cIndex">
                      <input type="text" class="name" v-model="cItem.name">
                      <!-- <i class="el-icon-delete" @click="operateDialogInfo('infoDeleteDepartment', {cIndex: cIndex, cItem: cItem})"></i> -->
                      <i class="el-icon-delete" plain @click="openHintBox({cIndex: cIndex, cItem: cItem, parent_name: departmentData.departmentInfo.parent[departmentData.departmentInfo.parent.length-1].name})"></i>
                      
                    </li>
                    <!-- 添加按钮 -->
                    <li class="list add" @click="addDeInput">
                      <i class="el-icon-plus"></i>
                      添加
                    </li>
                    <!-- 确认按钮 -->
                    <el-button class="confirm" @click="operateDialogInfo('updateDepartmentInfo', {})">确 认</el-button>
                  </ul>
                  <!-- 下级部门列表为空 -->
                  <p class="listNull" :class="{hide: departmentData.departmentInfo.parent.length !== 5}">没有下级部门</p>
                </ul>
              </div>
            </div>
          </el-tab-pane>

          <!-- 权限 -->
          <el-tab-pane class="list auth" label="权限" name="auth">
            <!-- 新增按钮 -->
            <el-button type="primary" class="addBtn" @click="expShowMsg">新增角色</el-button>
            <!-- 角色列表 -->
            <el-table
              v-loading="roleData.loading"
              :data="roleData.list"
              style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                min-width="10%">
              </el-table-column>
              <el-table-column
                prop="role_name"
                label="角色名称"
                min-width="15%">
              </el-table-column>
              <el-table-column
                label="描述"
                min-width="15%">
                <template slot-scope="scope">
                  <span>{{scope.row.role_desc == '' ? '/' : scope.row.role_desc}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="用户列表"
                min-width="50%">
                <template slot-scope="scope">
                  <span class="userListText" v-for="(item, index) in scope.row.user_list" :key="index">{{item.user_name}}{{index === scope.row.user_list.length-1 ? '' : '，'}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                min-width="10%">
                <template slot-scope="scope">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="RoleAuthAllot(scope.row.role_id)">权限分配</el-dropdown-item>
                      <el-dropdown-item @click.native="operateDialogInfo('userMaintain',scope.row)">用户维护</el-dropdown-item>
                      <el-dropdown-item @click.native="operateDialogInfo('alterRole',scope.row)">修改角色</el-dropdown-item>
                      <el-dropdown-item @click.native="operateDialogInfo('deleteRole',scope.row)">删除角色</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <el-button type="text" @click="RoleAuthAllot(scope.row.role_id)">权限分配</el-button>
                  <el-button type="text" @click="operateDialogInfo('userMaintain',scope.row)">用户维护</el-button>
                  <el-button type="text" @click="operateDialogInfo('alterRole',scope.row)">修改角色</el-button>
                  <el-button type="text" @click="operateDialogInfo('deleteRole',scope.row)">删除角色</el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging" v-if="roleData.pageCount > 1">
              <el-pagination
                @current-change="rolePageChange"
                :current-page.sync="roleData.paging.page"
                layout="prev, pager, next, jumper"
                :page-count="roleData.pageCount">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!--对话框-->
        <el-dialog
          :class="{userMaintainDialog: dialogData.type === 'userMaintain', biometricsDialog: dialogData.type === 'biometrics'}"
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 添加/修改用户 -->
          <div
            v-if="dialogData.type === 'addUser' || dialogData.type === 'alterUser'">
              <el-form
              label-width="90px"
              :model="dialogData.info">
              <el-form-item label="姓名:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.user_name"></el-input>
                </div>
              </el-form-item>
              <el-input style="position:fixed;bottom:-9999px"></el-input>
              <el-input type="password" style="position:fixed;bottom:-9999px"></el-input>
              <el-form-item label="账号:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.user_account" placeholder="字母或者数字的组合，限制6~15位" autocomplete="new-user"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="密码:">
                <div class="inputBox" v-if="dialogData.info.isAlter">
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass" placeholder="[要更改保存的密码，请单击这里]"></el-input>
                </div>
                <div class="inputBox" v-else>
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="手机号码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.phone_no" autocomplete="new-phone"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="邮箱:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.email"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="部门:">
                <div class="inputBox">
                  <el-select
                    class="inputBox"
                    v-model="dialogData.info.department_id"
                    placeholder="请选择上级部门">
                    <el-option
                      v-for="item in departmentData.unbankedList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="权限:">
                <div class="inputBox">
                  <el-select v-model="dialogData.info.role_id" multiple placeholder="请选择">
                    <el-option
                      v-for="(item, index) in roleData.list"
                      :key="index"
                      :label="item.role_name"
                      :value="item.role_id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateUser()">确 认</el-button>
            </div>
          </div>

          <!-- 修改用户状态 -->
          <div
            v-else-if="dialogData.type === 'changeUserStatus'">
            <p class="text">
              当前客户状态为
              <span class="bold">
                {{dialogData.info.user_state === '1' ? '正常' : '禁用'}}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
                {{dialogData.info.user_state === '1' ? '禁用' : '正常'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeUserStatus()">{{dialogData.info.user_state === '1' ? '禁用' : '正常'}}</el-button>
            </div>
          </div>

          <!-- 查看生物特征 -->
          <div
            class="biometrics"
            v-else-if="dialogData.type === 'biometrics'">
            <el-tabs v-model="userData.biometricsActiveTab">
              <!-- 指纹 -->
              <el-tab-pane label="指纹" name="1">
                <el-form label-width="70px">
                  <el-form-item label="指纹1:">
                    <div class="inputBox clearfix">
                      <el-input class="input" v-model="userData.biometricsData.fingerprint[0]"></el-input>
                      <i class="el-icon-circle-plus-outline" @click="addFS"></i>
                  </div>
                  </el-form-item>
                  <el-form-item
                    v-for="(item, index) in userData.biometricsData.fingerprint"
                    :key="index"
                    :class="{hide: index === 0}">
                    <span class="label">指纹{{index+1}}:</span>
                    <div class="inputBox clearfix">
                      <el-input class="input" v-model="userData.biometricsData.fingerprint[index]"></el-input>
                      <i class="el-icon-remove-outline" @click="deleteFS(index)"></i>
                  </div>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <!-- 人脸 -->
              <el-tab-pane label="人脸" name="2">
                <div class="faceBox clearfix">
                  <span class="label">人脸：</span>
                  <div class="right">
                    <!-- 图片列表 -->
                    <div
                      class="imgLi el-upload-list--picture-card"
                      v-for="(item, index) in userData.biometricsData.faceimage"
                      :key="index">
                      <img class="faceImg" :src="item" alt="">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview">
                          <i class="el-icon-zoom-in" @click="handlePictureCardPreview({url: item})"></i>
                        </span>
                        <span class="el-upload-list__item-delete">
                          <i class="el-icon-delete" @click="deleteFaceImage(index)"></i>
                        </span>
                      </span>
                    </div>
                    <!-- 上传 -->
                    <el-upload
                      action="#"
                      ref="uploadImage"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :on-success="handlePictureSuccess"
                      :show-file-list="false"
                      :http-request="uploadImage">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <!-- <el-upload
                      action="http://47.106.238.136/online/index.php/v4/client/user/uploadImage"
                      ref="uploadImage"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :http-request="uploadImage"
                      :show-file-list="false">
                      <i class="el-icon-plus"></i>
                    </el-upload> -->
                  </div>
                  <el-dialog :visible.sync="userData.faceData.dialogVisible">
                    <img width="100%" :src="userData.faceData.imageUrl" alt="">
                  </el-dialog>
                </div>
              </el-tab-pane>
              <!-- 员工卡 -->
              <el-tab-pane label="员工卡" name="3">
                <el-form label-width="70px">
                  <el-form-item label="员工卡1:">
                    <div class="inputBox clearfix">
                      <el-input class="input" v-model="userData.biometricsData.staffcard[0]"></el-input>
                      <i class="el-icon-circle-plus-outline" @click="addFS"></i>
                  </div>
                  </el-form-item>
                  <el-form-item
                    v-for="(item, index) in userData.biometricsData.staffcard"
                    :key="index"
                    :class="{hide: index === 0}">
                    <span class="label">员工卡{{index+1}}:</span>
                    <div class="inputBox clearfix">
                      <el-input class="input" v-model="userData.biometricsData.staffcard[index]"></el-input>
                      <i class="el-icon-remove-outline" @click="deleteFS(index)"></i>
                  </div>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <!-- 确认按钮 -->
            <el-button class="confirmBtn" type="primary" @click="updateUserProfile">确认</el-button>
          </div>

          <!--单个 添加/编辑部门 -->
          <div
            v-else-if="dialogData.type === 'addDepartment' || dialogData.type === 'editDepartment'">
            <el-form
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="部门名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="上级部门:">
                <div class="inputBox">
                  <el-select
                    v-model="dialogData.info.parent_id"
                    placeholder="请选择上级部门">
                    <el-option
                      v-for="item in departmentData.unbankedList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.is_child || item.level === 5">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogUpdateDepartment()">确 认</el-button>
            </div>
          </div>

          <!-- 单个删除部门 -->
          <div
            v-else-if="dialogData.type === 'deleteDepartment'">
            <p class="text">
              删除后，该部门的所有用户将移至
              <span class="bold">
                {{dialogData.info.parent_name === null ? '全部' : dialogData.info.parent_name}}
              </span>
              ，确认要删除
              <span class="bold">
                {{dialogData.info.name}}
              </span>
              ？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="dialogUpdateDepartment()">确 认</el-button>
            </div>
          </div>

          <!-- 部门信息-批量更新部门 -->
          <div
            v-else-if="dialogData.type === 'updateDepartmentInfo'">
            <p class="text">
              确认更新数据？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancelUpdateDepartment">取 消</el-button>
              <el-button @click="updateDepartmentInfo">确 认</el-button>
              <!-- <el-button @click="deleteDeInput(dialogData.info.cIndex, dialogData.info.cItem)">确 认</el-button> -->
            </div>
          </div>

          <!-- 添加/修改角色 -->
          <div
            v-else-if="dialogData.type === 'addRole' || dialogData.type === 'alterRole'">
            <el-form
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="角色名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.role_name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="描述:">
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" rows="3" v-model="dialogData.info.role_desc"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateRole">确 认</el-button>
            </div>
          </div>

          <!-- 删除角色 -->
          <div
            v-else-if="dialogData.type === 'deleteRole'">
            <p class="text">
              确认删除角色
              <span class="bold">
                {{dialogData.info.role_name}}
              </span>
              ？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteRole()">确 认</el-button>
            </div>
          </div>

          <!-- 用户维护 -->
          <div
            class="userMaintainBox clearfix"
            v-else-if="dialogData.type === 'userMaintain'">
            <!-- 内容左边区域 -->
            <div class="contentLeftArea">
              <!-- 部门列表 -->
              <el-tree
                class="defineTree"
                v-loading="departmentData.loading"
                :data="departmentData.list"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <!-- 自定义icon -->
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span
                    class="label"
                    :class="data.id === roleUser.selected ? 'selected' : ''"
                    @click="getRoleUser(data.id)">{{ node.label }}</span>
                </span>
              </el-tree>
              <!-- 部门列表为空 -->
              <p class="contentNull" v-show="departmentData.list[0].children.length === 0">请点击部门结构旁边的添加按钮，或者在右边页面进行添加部门的操作</p>
            </div>

            <!-- 内容右边区域 -->
            <div class="contentRightArea" v-loading="roleUser.loading">
              
              <!-- 已选择列表 -->
              <div class="list clearfix">
                <el-checkbox class="checkAll" :indeterminate="roleUser.select.isIndeterminate" v-model="roleUser.select.checkAll" @change="selectCheckAllChange">已选择</el-checkbox>
                <el-checkbox-group class="group" v-model="roleUser.select.checkedList" @change="checkedSelectChange">
                  <div class="checkItem" v-for="(item, index) in roleUser.select.list" :key="index">
                  <el-checkbox class="check" :label="item.user_id">{{item.user_name}}</el-checkbox>
                  </div>
                </el-checkbox-group>
                <!-- 已选择列表为空 -->
                <p class="listNull" v-if="roleUser.select.list.length === 0">没有已选择的用户</p>
              </div>

              <!-- 未选择列表 -->
              <div class="list clearfix">
                <el-checkbox class="checkAll" :indeterminate="roleUser.notSelect.isIndeterminate" v-model="roleUser.notSelect.checkAll" @change="notSelectCheckAllChange">未选择</el-checkbox>
                <el-checkbox-group class="group" v-model="roleUser.notSelect.checkedList" @change="checkedNotSelectChange">
                  <div class="checkItem" v-for="(item, index) in roleUser.notSelect.list" :key="index">
                  <el-checkbox class="check" :label="item.user_id">{{item.user_name}}</el-checkbox>
                  </div>
                </el-checkbox-group>
                <!-- 未选择列表为空 -->
                <p class="listNull" v-if="roleUser.notSelect.list.length === 0">没有未选择的用户</p>
              </div>

              <!-- 操作按钮 -->
              <div slot="footer" class="dialog-footer" v-if="!(roleUser.notSelect.list.length === 0 && roleUser.select.list.length === 0)">
                <el-button class="confirm" @click="updateRoleUser()">确 认</el-button>
                <el-button @click="dialogData.visible = false">取 消</el-button>
              </div>

            </div>
          </div>

        </el-dialog>
        

        <!--批量导入弹窗-->
        <el-dialog title="批量导入" :visible.sync="batchDio" width="600px">
          <div class="cont_dio">
            <el-row type="flex" align="middle">
              <el-col :span="18">请下载模版，并按模版格式录入用户信息</el-col>
              <el-col :span="6" class="tr"><el-button type="primary" @click="downloadTemp">下载模板</el-button></el-col>
            </el-row>

            <el-form ref="form" :model="batchform" label-width="90px">
              <el-form-item label="上传文件：">
                <el-upload
                  class="upload-demo"
                  action="fileUrl"
                  :http-request="uploadFile"
                  :limit="1"
                  multiple
                  :on-exceed="handleExceed"
                  :before-upload="beforeAvatarUpload"
                  :on-change="handleChange"
                  :file-list="fileList">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            
          </div>
        </el-dialog>
      </div>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast, updataBreadCrumb, deepCopy, consoleLog, showLoading, hideLoading, showMsg } from "../../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../../static/js/api.js"
  import * as config from "../../../../../static/js/config.js"
  import * as expConfig from "../../../../../static/js/exp/config.js"
  import { expUserApi } from "../../../../../static/js/exp/user.js"
  let vm 

  export default {
    name: 'ExpCOrganizeManage',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        // 调用角色用户列表API次数
        count : 0,
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 当前显示tab，默认显示用户
        activeTab: '',
        // 用户数据
        userData: {
          // 分页数据  page为当前页，perPage为每页数量，phone_no账号搜索，user_name用户姓名搜索
          paging: {
            page: 1,
            perPage: 10,
            department_id: '0',
            phone_no: '',
            user_account:'',//账号
            user_name: ''
          },
          // 用户列表
          list: [],
          loading: false,
          // 当前选中部门
          selected: 0,
          // 查看生物特征 -- 当前显示tab,默认显示指纹(1指纹 2人脸 3员工卡)
          biometricsActiveTab: '1',
          biometricsData: {
            fingerprint: [''],
            faceimage: [],
            staffcard: ['']
          },
          faceData: {
            imageUrl: '',
            dialogVisible: false,
          },
        },
        // 部门结构数据
        departmentData: {
          // 部门列表
          list: [
            {children: []}
          ],
          loading: false,
          // 当前选中部门
          selected: 0,
          // 未分组部门列表
          unbankedList:[],
          // 部门详情
          departmentInfo: {
            parent: [],
            children: []
          },
          // 更新的部门信息
          updateData:{},
          // 删除的已存在的部门信息
          deleteInfo: []
        },
        // 树形控件配置
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        // 权限角色数据
        roleData: {
          // 分页数据  page为当前页，perPage为每页数量
          paging: {
            page: 1,
            perPage: 10
          },
          // 角色列表
          list: [],
          loading: false,
        },
        // 用户维护 -- 角色用户
        roleUser: {
          // 已选择列表数据
          select: {
           // 已选择列表
            list: [],
            // 已选择列表 -- 当前选中的数据
            checkedList:[],
            checkedAllList:[],
            checkAll: true,
            isIndeterminate: true
          },
          // 未选择列表数据
          notSelect: {
            // 未选择列表
            list: [],
            // 未选择列表 -- 当前选中的数据
            checkedList:[],
            checkedAllList:[],
            checkAll: false,
            isIndeterminate: true
          },
          loading: false,
          // 当前选中的部门id
          selected: '0'
        },

        batchDio:false,//批量导入弹窗
        batchform:{
          tempUrl:'',//下载模板地址
          batch_url:'',//批量上传url
        },
        fileUrl: config.address+'/user/batchAddUser',//文件上传地址
        fileList:[],//文件列表
      }
    },
    mounted(){
      this.getDepartmentList()
      // this.getRoleList()
      // console.log('this.$store.state.authSuccessShowTab', this.$store.state.authSuccessShowTab)
      this.activeTab = 'user'
      // this.activeTab = this.$store.state.authSuccessShowTab === '' ? 'user' :  this.$store.state.authSuccessShowTab
    },
    created: function () {
      vm = this
    },
    methods: {
      // 体验提示
      expShowMsg() {
        showMsg('体验环境下，该功能无法使用', 'warning')
      },
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo (type, info, node) {
        console.log('info', info)
        // console.log('type', type)
        // 重置调用角色用户列表API次数
        this.count = 0
        // 用户信息
        let userInfo
        if (type === 'addUser' || type === 'alterUser') {
          // 获取部门id
          let id = this.userData.selected
          // 获取未排序部门列表
          this.getAllDepartment(id)
          userInfo = {
            department_id: this.userData.selected,
            user_id: '',
            user_name: '',
            phone_no: '',
            user_account:'',
            password:'',
            email: '',
            role_id: []
          }
          if(type == 'alterUser'){
            info.password=''
            info.isAlter = '1'
          }
          // console.log('userInfo', userInfo)
        }

        // 添加/修改部门
        let departmentInfo
        if (type === 'addDepartment' || type === 'editDepartment') {
          // console.log('this.roleData.list', this.roleData.list)
          // 获取上级部门id
          let id = info ? info.id : ''
          // 获取未排序部门列表
          this.getAllDepartment(id)
          departmentInfo = {
            id: '',
            name: '',
            parent_id: 0
          }
        }

        // 角色信息
        let roleInfo = {
          role_id: '',
          role_name: '',
          role_desc: ''
        }

        // 确认更新部门信息
        if (type === 'updateDepartmentInfo') {
          let children = this.departmentData.departmentInfo.children
          for (let i in children) {
            // 判断
            if (children[i].name === '') {
              showToast('部门名称不能为空！')
              return
            }
          }
        }

        let title = type === 'addUser' ? '添加用户' :
                    type === 'alterUser' ? '修改用户' :
                    type === 'biometrics' ? '生物特征' :
                    type === 'addDepartment' ? '添加部门' :
                    type === 'editDepartment' ? '编辑部门' :
                    type === 'deleteDepartment' ? '删除部门' :
                    type === 'updateDepartmentInfo' ? '更新部门' :
                    type === 'addRole' ? '添加角色' :
                    type === 'alterRole' ? '修改角色' :
                    type === 'userMaintain' ? '用户维护' : ''
        this.dialogData = {
          type: type,
          title: title,
          visible: !(this.dialogData.visible),
          isReset: false,
          info: type === 'addDepartment' ? departmentInfo :
                type === 'addRole' ? roleInfo :
                type === 'addUser' ? userInfo : deepCopy(info)
        }

        // 获取生物特征
        if (type === 'biometrics') {
          this.getUserProfile()
        }
        
        // 角色信息
        if (type === 'userMaintain') {
          // this.getRoleUser(info.department_id, info.role_id)
          // 已选择列表数据
          this.roleUser = {
            // 已选择列表数据
            select: {
              // 已选择列表
              list: [],
              // 已选择列表 -- 当前选中的数据
              checkedList:[],
              checkedAllList:[],
              checkAll: true,
              isIndeterminate: true
            },
            // 未选择列表数据
            notSelect: {
              // 未选择列表
              list: [],
              // 未选择列表 -- 当前选中的数据
              checkedList:[],
              checkedAllList:[],
              checkAll: false,
              isIndeterminate: true
            },
            loading: false,
            // 当前选中的部门id
            selected: '0'
          }
          this.getRoleUser('0')
        }

        // console.log('this', this.dialogData)
      },
      cancel () {
        vm.dialogData.visible = false
      },

      /* 用户 */
      // 选择部门
      treeNodeClick (data) {
        vm.userData.selected = data.id
      },
      // 获取用户列表
      getUserList: async function () {
        let res = await expUserApi.getUserList()
        vm.userData.list = [...res.data]
      },
      // 获取用户生物特征
      getUserProfile: async function () {
        vm.userData.biometricsActiveTab = '1'
        let biometricsData = vm.dialogData.info.userProfile
        vm.userData.biometricsData = biometricsData
        if (biometricsData.fingerprint === []) {
          vm.userData.biometricsData.fingerprint.push('')
        }
        if (biometricsData.staffcard === []) {
          vm.userData.biometricsData.staffcard.push('')
        }
      },
      // 添加指纹/添加员工卡
      addFS: function () {
        let activeTab = this.userData.biometricsActiveTab
        if (activeTab === '1') {
          this.userData.biometricsData.fingerprint.push('')
        } else {
          this.userData.biometricsData.staffcard.push('')
        }
      },
      // 删除指纹/删除员工卡
      deleteFS: function (index) {
        let activeTab = this.userData.biometricsActiveTab
        if (activeTab === '1') {
          this.userData.biometricsData.fingerprint.splice(index, 1)
        } else {
          this.userData.biometricsData.staffcard.splice(index, 1)
        }
      },
      // 预览图片
      handlePictureCardPreview(file) {
        console.log('file', file)
        this.userData.faceData.imageUrl = file.url;
        this.userData.faceData.dialogVisible = true;
      },
      // 上传成功
      handlePictureSuccess (response, file, fileList) {
        let url = file.url
        vm.userData.biometricsData.faceimage.push(url)
      },
      // 删除图片
      deleteFaceImage (index) {
        vm.userData.biometricsData.faceimage.splice(index, 1)
      },
      // 上传图片
      uploadImage: async function (content) {
        // console.log('content', content)
        // let formData = new FormData()
        // formData.append('file', content.file)
        // console.log('formData', formData)
        // formData.append('type', '86676')
        // let res = await userApi.uploadImage(formData)
        // if (res.meta.code === 200) {
        //   vm.userData.biometricsData.faceimage.push(res.data)
        //   showToast('上传成功')
        // } else {
        //   showToast(res.meta.message)
        // }
      },
      // 更新用户生物特征
      updateUserProfile: async function () {
        let vm = this
        let activeTab = vm.userData.biometricsActiveTab
        let fingerprint = vm.userData.biometricsData.fingerprint
        let faceimage = vm.userData.biometricsData.faceimage
        let staffcard = vm.userData.biometricsData.staffcard
        let data = {
          user_id: vm.dialogData.info.user_id,
          type: activeTab,
          data: activeTab === '1' ? fingerprint : activeTab === '2' ? faceimage : staffcard
        }

        let res = await expUserApi.updateUserProfile(data)
        vm.cancel()
        showToast('更新成功')
        vm.getUserList()
      },
      // 修改用户状态
      changeUserStatus: async function () {
        let vm = this
        let data = {
          user_id: vm.dialogData.info.user_id
        }

        let res = await expUserApi.changeUserStatus(data)
        vm.cancel()
        showToast('更新成功')
        vm.getUserList()
      },
      // 更新（添加/修改）用户
      updateUser: async function () {
        let data = {
          user_id: vm.dialogData.info.user_id,
          user_name: vm.dialogData.info.user_name,
          user_account: vm.dialogData.info.user_account,
          // password: vm.dialogData.info.password,
          phone_no: vm.dialogData.info.phone_no,
          email: vm.dialogData.info.email,
          department_id: vm.dialogData.info.department_id,
          role_id: vm.dialogData.info.role_id
        }
        if(vm.dialogData.info.isAlter){
          if(vm.dialogData.info.password){
            data.password= vm.dialogData.info.password
          }
        }else{
          data.password= vm.dialogData.info.password
        }

        // 判断
        if (data.user_name === '') {
          showToast('姓名不能为空！')
          return
        }
        let reUser = new RegExp(/^[0-9a-zA-Z]{6,15}$/)
        if (data.user_account === '') {
          showToast('账号不能为空！')
          return
        } 
        // else if (!reUser.test(data.user_account)) {
        //   showToast('请填写6-15位字母和数字组合的账号')
        //   return
        // }
        let rePass = new RegExp(/^[\w]{6,20}$/)
        if (data.password === '') {
          showToast('密码不能为空！')
          return
        } else if (!rePass.test(data.password)) {
          showToast('请填写6-20位字母、数字和下划线组合的密码')
          return
        }
        if (data.phone_no === '') {
          showToast('手机号码不能为空！')
          return
        } else if (data.phone_no.length !== 11) {
          showToast('请填写正确的手机号！')
          return
        }
        if (data.email === '') {
          showToast('邮箱不能为空！')
          return
        }
        // if (data.role_id.length === 0) {
        //   showToast('请选择权限！')
        //   return
        // }

        console.log('data', data)
        // return

        let res = await expUserApi.updateUser(data)
        vm.cancel()
        showToast('更新成功')
        vm.getUserList()
      },
      // 用户列表当前页值改变，获取新用户列表
      userPageChange(val) {
        this.getUserList()
      },


       /* 部门 */
      // 获取部门列表
      async getDepartmentList () {
        let vm = this
        let res = await expUserApi.getDepartmentList()
        vm.departmentData.list = [...res.data]
      },
      // 获取所有未分组部门列表
      async getAllDepartment (id) {
        // console.log('id', id)
        let data = { id }
        let res = await expUserApi.getAllDepartment(data)
        console.log('res', res.data)
        vm.departmentData.unbankedList = [...res.data]
      },
      // 获取部门详情
      async getDepartmentInfo (id) {
        vm.departmentData.selected = id
        let data = { id }
        let res = await expUserApi.getDepartmentInfo(data)
        vm.departmentData.departmentInfo = res.data
      },
      // 单个添加编辑
      dialogUpdateDepartment () {
        let type = vm.dialogData.type
        let info = vm.dialogData.info
        if (info.name == '') {
          showToast('请输入部门名称')
          return
        }
        let data = {
          parent_id: info.parent_id
        }
        if (type == 'addDepartment') {
          data.add = [info.name]
        }
        if (type == 'editDepartment') {
          data.edit = [{id: info.id, name: info.name}]
        }
        if (type === 'deleteDepartment') {
          data.delete = [info.id]
        }
        // console.log('info', info)
        console.log('data', data)
        // return
        vm.updateDepartment(type, data)
      },
      // 添加部门input
      addDeInput: function () {
        let vm = this
        let addInfo = {
          id: '',
          name: ''
        }
        vm.departmentData.departmentInfo.children.push(addInfo)
        // console.log('vm.departmentData.departmentInfo.children', vm.departmentData.departmentInfo.children)
      },
      // 右侧 -- 删除部门信息提示框
      openHintBox(info) {
        console.log('info', info)
        this.deleteDeInput(info.cIndex, info.cItem)
        if (info.cItem.id === '') {
          return
        }
        // 提示
        const h = this.$createElement;
        let msg = '删除后，该部门的所有用户将移至 ' + (info.parent_name === null ? '全部' : info.parent_name)

        this.$notify({
          title: '提示',
          message: h('i', { style: 'color: teal'}, msg)
        })
      },
      // 删除部门input
      deleteDeInput: function (index, cItem) {
        console.log('index', index, cItem)
        // return
        vm.departmentData.departmentInfo.children.splice(index, 1)
        // 删除的部门有id
        if (cItem.id !== '') {
          // 获取更新部门数据---添加的部门
          // vm.departmentData.updateData.update.splice(index, 1)
          // vm.departmentData.updateData.delete.push(cItem.id)
          vm.departmentData.deleteInfo.push({index: index, cItem: cItem})
        }
        // console.log('删除vm.departmentData.departmentInfo.children', vm.departmentData.departmentInfo.children)
      },
      // 取消批量更新部门
      cancelUpdateDepartment: function () {
        let deleteInfo = [...vm.departmentData.deleteInfo]
        // 取消删除，显示之前删除的已存在的信息
        deleteInfo.forEach(function (item, index) {
          vm.departmentData.departmentInfo.children.splice(item.index, 0, item.cItem)
        })        
        vm.dialogData.visible = false
        // 清空删除信息
        vm.departmentData.deleteInfo = []
      },
      // 批量更新（添加、修改、删除）
      updateDepartmentInfo () {
        console.log('vm.departmentData.deleteInfo', vm.departmentData.deleteInfo)
        let data = {
          parent_id: vm.departmentData.selected,
          add: [],
          edit: [],
          delete: []
        }
        let info = vm.departmentData.departmentInfo.children
        for (let i = 0; i < info.length; i++) {
          let item = info[i]
          if (item.id === '') {
            data.add.push(item.name)
          } else {
            data.edit.push(item)
          }
        }
        let deleteInfo = vm.departmentData.deleteInfo
        for (let i = 0; i < deleteInfo.length; i++) {
          data.delete.push(deleteInfo[i].cItem.id)
        }
        console.log('data', data)
        // return
        vm.updateDepartment('updateDepartmentInfo', data)
      },
      // 添加/修改部门信息
      async updateDepartment (type, data) {
        let text = type === 'addDepartment' ? '添加' : type === 'editDepartment' ? '修改' : '更新'
        showLoading('正在'+text)
        let res = await expUserApi.updateDepartment(data)
        // setTimeout(() => {
          hideLoading()
          vm.cancel()
          showToast(text + '成功')
          if (type === 'updateDepartmentInfo') { vm.departmentData.deleteInfo = [] }
          vm.getDepartmentList()
        // }, 500);
      },


      //上传文件
      async uploadFile(param){
        let that = this
        let formData = new FormData()
        // console.log('param',param)
        formData.append('file', param.file)
        formData.append('type', 'file')
        formData.append('department_id',that.userData.selected)
        let res = await userApi.batchAddUser(formData)
        if (res.meta.code === 200) {
          // that.addform.show_url = res.data.show_url
          that.batchform.batch_url = res.data
          that.batchDio = false;
          that.batchform.batch_url=''
          that.fileList=[]
          that.getUserList(that.userData.selected)
          showToast('成功导入'+res.data.num+'条')
        } else {
          // that.$message.error(res.meta.message)
        }
      },
      handleChange(file, fileList) {
        this.fileList = fileList.slice(-1);
      },
      handleExceed(files, fileList) {
        showToast('只能上传1个文件！')
        // this.$message.warning('只能上传1个文件！')
      },
      //上传文件校验
      beforeAvatarUpload(file) {
        let lastof = file.name.substring(file.name.lastIndexOf(".") + 1);
        const isXls = lastof === "xls";
        const isXlsx = lastof === "xlsx";
        const isLt2M = file.size / 1024 < 2000;
        if (!isLt2M) {
          showToast('文件不能大于2M！')
          // this.$message.error('文件不能大于2M！');
          this.fileList=[]
          this.batchform.batch_url=''
        }
        if (!isXls && !isXlsx) {
          showToast('请上传Excel文件！')
          // this.$message.error('请上传Excel文件！');
          this.fileList=[]
          this.batchform.batch_url=''
        }
        return isLt2M && (isXls || isXlsx);
      },

      //打开批量导入弹窗 
      openBatch(){
        this.batchDio = true;
      },
      //下载模板
      downloadTemp(){
        window.open(this.batchform.tempUrl)
      },

     

      /* 权限 */
      // 获取角色列表
      getRoleList: async function () {
        let res = await expUserApi.getRoleList()
        vm.roleData.list = [...res.data]
      },
      // 新增/修改角色
      updateRole: async function () {
        let vm = this
        let data = {
          role_id: vm.dialogData.info.role_id,
          role_name: vm.dialogData.info.role_name,
          role_desc: vm.dialogData.info.role_desc
        }
        console.log('data', data)
        let type = vm.dialogData.type

        // 判断
        if (data.role_name === '') {
          showToast('请输入角色名称！')
          return
        }
        if (data.role_desc === '') {
          showToast('请输入描述！')
          return
        }

        let res = await expUserApi.updateRole(data)
        vm.cancel()
        vm.getRoleList()
      },
      // 删除角色
      deleteRole: async function () {
        let vm = this
        let data = {
          role_id: vm.dialogData.info.role_id
        }

        let res = await expUserApi.deleteRole(data)
        vm.cancel()
        vm.getRoleList()
      },
      /* 已选择框 */
      // 已选择 -- 所有选中状态变化
      selectCheckAllChange(val) {
        // console.log('val', val)
        this.roleUser.select.checkedList = val ? this.roleUser.select.checkedAllList : []
        this.roleUser.select.isIndeterminate = false
      },
      // 已选择 -- 单个选中状态变化
      checkedSelectChange(value) {
        // console.log('value', value)
        let checkedCount = value.length
        let listLength = this.roleUser.select.list.length
        this.roleUser.select.checkAll = checkedCount === listLength
        this.roleUser.select.isIndeterminate = checkedCount > 0 && checkedCount < listLength
      },
      /* 未选择框 */
      // 未选择 -- 所有选中状态变化
      notSelectCheckAllChange(val) {
        // console.log('val', val)
        let vm = this
        // vm.roleUser.notSelect.checkedList = val ? vm.roleUser.notSelect.checkedAllList : []
        // vm.roleUser.notSelect.isIndeterminate = false

        // 处理
        let notSelectList = [...vm.roleUser.notSelect.list]
        notSelectList.filter(function (nItem, index) {
          // select添加
          vm.roleUser.select.list.push(nItem)
          vm.roleUser.select.checkedAllList.push(nItem.user_id)
          vm.roleUser.select.checkedList.push(nItem.user_id)
        })

        // noSelect移除(全选清空noSelect列表数据)
        vm.roleUser.notSelect.list = []
        vm.roleUser.notSelect.checkedList = []
        vm.roleUser.notSelect.checkedAllList = []
        
      },
      // 未选择 -- 单个选中状态变化
      checkedNotSelectChange(value) {
        let vm = this
        // console.log('value', value)
        let checkedCount = value.length
        let notSelectList = [...vm.roleUser.notSelect.list]
        // vm.roleUser.notSelect.checkAll = checkedCount === notSelectList.length
        // vm.roleUser.notSelect.isIndeterminate = checkedCount > 0 && checkedCount < notSelectList.length

        // 处理
        notSelectList.filter(function (nItem, index) {
          // noSelect列表检测到已选中的数据，转移给select列表
          if (value.indexOf(nItem.user_id) !== -1){
            // select添加
            vm.roleUser.select.list.push(nItem)
            vm.roleUser.select.checkedAllList.push(value[0])
            vm.roleUser.select.checkedList.push(value[0])

            // noSelect移除(始终没有已选中数据)
            vm.roleUser.notSelect.list.splice(index, 1)
            vm.roleUser.notSelect.checkedAllList.splice(index, 1)
            vm.roleUser.notSelect.checkedList = []
          }
        })
        
        // console.log('vm.roleUser.notSelect.checkedList', vm.roleUser.notSelect.checkedList)
        // console.log('vm.roleUser.select.checkedAllList', vm.roleUser.select.checkedAllList)
      },
      // 获取角色用户
      getRoleUser: async function (department_id) {
        let data = {
          select: [
            {user_id:1,user_name:'张三'}
          ],
          notSelect: [
            {user_id:2,user_name:'李四'},
            {user_id:3,user_name:'王五'},
          ],
        }

        vm.roleUser.select.checkedList = [1]
        vm.roleUser.select.list = data.select
        vm.roleUser.notSelect.checkedList = []
        vm.roleUser.notSelect.list = data.notSelect
        return
        // // console.log('vm.dialogData.info.role_id', vm.dialogData.info.role_id)
        // // 重置未选择checkAll状态
        // // vm.roleUser.select.isIndeterminate = false
        // vm.roleUser.selected = department_id
        // let data = {
        //   role_id: vm.dialogData.info.role_id,
        //   department_id: department_id
        // }

        // vm.roleUser.loading = true
        // let res = await userApi.getRoleUser(data)
        // vm.roleUser.loading = false
        // if (res.meta.code === 200) {
        //   // console.log('角色用户res', res)
        //   vm.count++
        //   // console.log('count', vm.count)
        //   vm.processRoleUser(department_id, res.data)
        // } else {
        //   showToast(res.meta.message)
        // }
      },
      // 更新角色用户
      updateRoleUser: async function () {
        vm.cancel()
        return
        let data = {
          role_id: vm.dialogData.info.role_id,
          user_id: vm.roleUser.select.checkedList
        }

        let res = await userApi.updateRoleUser(data)
        if (res.meta.code === 200) {
          showToast('更新角色用户成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getRoleList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 去角色权限分配
      RoleAuthAllot(role_id) {
        // console.log('role_id: ',role_id);
        let navBarActive = [{function_tab: 'COrganizeAuthAllot', function_name: '权限分配'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/Exp/COrganizeAuthAllot',
          query: {role_id: role_id}
        })
      },


      // 角色列表当前页值改变，获取新的角色列表
      rolePageChange(val) {
        // console.log(`当前页: ${val}`);
        this.getRoleList()
      },
      // 处理角色用户数据
      processRoleUser: function (department_id, data) {
        // console.log('department_id', department_id)
        let vm = this
        // console.log('vm.roleUser.select.checkedAllList', vm.roleUser.select.checkedAllList)
        // 获取select数据（当为全部，并且count=1）
        if (department_id === '0') {
          let selectList = [...data.select]
          // count代表每一个dialog只获取一次已选择列表
          // console.log('count', vm.count)
          if (vm.count === 1) {
            // 获取已选择列表
            vm.roleUser.select.list = [...selectList]
            // 获取全部选择的list
            for (let i in selectList) {
              vm.roleUser.select.checkedAllList.push(selectList[i].user_id)
            }
            vm.roleUser.select.checkedList = [...vm.roleUser.select.checkedAllList]
          }
        }
        

        // 获取未选择列表
        let notSelectList = [...data.notSelect]
        // 筛选noSelect列表数据（去除select中已有的）倒着遍历
        let selectCheckedAllList = [...vm.roleUser.select.checkedAllList]  //已选择全部选中列表
        // console.log('selectCheckedAllList', selectCheckedAllList)
        for (let nIndex = notSelectList.length -1; nIndex >= 0; nIndex--) {
          let nItem = notSelectList[nIndex]
          // 检测到有重复的user_id，删除
          if (selectCheckedAllList.indexOf(nItem.user_id) !== -1) {
            notSelectList.splice(nIndex, 1)
            vm.$forceUpdate()
          }
        }
        vm.roleUser.notSelect.list = [...notSelectList]

        // 获取全部选择的checkedAllList
        for (let i in notSelectList) {
          vm.roleUser.notSelect.checkedAllList.push(notSelectList[i].user_id)
        }
        // console.log('checkedAllList', vm.roleUser.notSelect.checkedAllList)
        
        // console.log('vm.roleUser', vm.roleUser)
      },
    },
    watch: {
      'activeTab'(newVal){
        if (newVal == 'user'){
          this.getUserList()
        } else if (newVal == 'department') {
          this.getDepartmentInfo(vm.departmentData.selected)
        } else if (newVal == 'auth') {
          this.getRoleList()
        }
      }
    }
  }
</script>

<style lang="scss">
.COrganizeManage {
  .mainBodyContent.border::after{
    height: calc(100% - 40px);
    content: '';
    border-right: 1px solid #E4E7ED;
    position: absolute;
    left: 270px;
    top: 40px;
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    // tab列表
    .tabList {
      // 权限tab
      .list.user {
        .contentRightArea {
          padding: 20px 20px 0 0;
          .searchArea {
            width: 100%;
            .text {
              width: 200px;
              margin-bottom: 20px;
              float: left;
              margin-right: 20px;
            }
            .searchBtn {
              float: left;
            }
          }
          .btnArea{
            margin: 20px 0 10px;
          }
        }
        
      }
      .list.auth {
        padding: 24px 32px;
        .addBtn {
          margin-bottom: 24px;
        }
      }
      // tabs标签
      .el-tabs__header {
        width: 100%;
        margin-bottom: 0;
        box-sizing: border-box;
        border-bottom: 1px solid #E4E7ED;
        .el-tabs__nav-wrap {
          padding-left: 20px;
          width: 360px;
        }
        .el-tabs__item {
          font-size: 18px;
        }
      }
    }
    // 内容左边
    .contentLeftArea {
      float: left;
      width: 270px;
      box-sizing: border-box;
      // 添加
      .leftTopArea{
        width: 100%;
        line-height: 40px;
        padding: 0 20px 0 10px;
        border-bottom: 1px solid #E4E7ED;
        .text{
          float: left;
          font-weight: bold; 
        }
        .icon {
          float: right;
          display: block;
          font-size: 20px;
          line-height: 40px;
        }
      }
      // 部门列表为空
      .contentNull {
        text-align: center;
        margin-top: 100px;
        padding: 0 20px;
        color: #cccccc;
        font-size: 14px;
      }
    }
    // 内容右边
    .contentRightArea {
      padding: 0 10px 10px;
      margin-left: 300px;
      .title {
        line-height: 40px;
        font-weight: bold; 
      }
      .updateWrapper {
        margin-top: 15px;
        .updateBox {
          .item {
            float: left;
            padding-right: 20px;
            font-size: 14px;
            line-height: 1;
            color: #606266;
            position: relative;
          }
          .item::before{
            content: '>';
            display: block;
            width: 20px;
            text-align: center;
            position: absolute;
            right: 0;
          }
        }
        // 下级部门列表 
        .listWrapper{
          float: left;
          width: 300px;
          .list{
            width: 100%;
            margin-bottom: 10px;
            .name {
              float: left;
            }
            .el-icon-delete{
              display: block;
              float: left;
              font-size: 18px;
              margin: 8.5px 0 8.5px 10px;
            }
          }
          .list .name,
          .list.add {
            width: 270px;
            font-size: 14px;
            height: 35px;
            line-height: 35px;
            padding-left: 5px;
            border: 1px solid #c0c4cc;
          }
          .list.add {
            border-style: dashed;
            text-align: center;
            color: #c0c4cc;
          }
          .confirm {
            padding: 9px 20px;
            border-radius: 0;
            margin-top: 10px;
          }
        }
        // 下级部门列表为空
        .listNull {
          float: left;
          text-align: center;
          font-size: 14px;
          line-height: 1;
          color: #cccccc;
        }
      }
    }

    // 对话框
    // 用户维护
    .userMaintainDialog {
      .el-dialog {
        width: 1000px;
      }
      .userMaintainBox {
        .contentLeftArea {
          height: 100%;
        }
        .contentRightArea {
          padding: 0;
          .list {
            margin-bottom: 30px;
            // .checkAll,
            // .group,
            // .listNull {
            //   float: left;
            // }
            .group{
              margin-left: 30px;
              display: flex;
              flex-wrap: wrap;
              .checkItem{
                width: 20%;
                margin-top: 10px;
              }
            }
            .listNull {
              font-size: 14px;
              color: #cccccc;
              padding-left: 4em;
            }
          }
        }
        .dialog-footer {
          text-align: left;
          .confirm {
            margin-right: 30px;
          }
        }
      }
    }
    // 生物特征
    .biometricsDialog {
      .el-dialog{
        width: 735px;
      }
      .biometrics {
        .el-form-item {
          .label {
            display: inline-block;
            width: 70px;
            line-height: 40px;
            padding-right: 12px;
            text-align: right;
            position: absolute;
            left: -70px;
          }
          .inputBox{
            width: 100%;
            .input {
              width: 92%;
              float: left;
            }
            i {
              width: 8%;
              float: left;
              font-size: 25px;
              line-height: 40px;
              text-align: center;
            }
          }
        }
        .faceBox {
          .label {
            width: 70px;
            padding-right: 12px;
            text-align: right;
            float: left;
            font-size: 14px;
          }
          .right {
            width: 624px;
            float: left;
            .imgLi {
              float: left;
              overflow: hidden;
              background-color: #fff;
              border: 1px solid #c0ccda;
              border-radius: 6px;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              width: 148px;
              height: 148px;
              margin: 0 8px 8px 0;
              display: inline-block;
              position: relative;
              .faceImg{
                width: 100%;
                height: 100%;
              }
            }
            .imgLi:hover {
              .el-upload-list__item-actions{
                opacity: 1;
              }
            }
            .el-upload {
              margin-bottom: 20px;
            }
          }
        }
      }
      .confirmBtn{
        margin-left: 70px;
      }
    }
  }
  
}

</style>



// WEBPACK FOOTER //
// src/components/ExpPage/CUserManege/COrganizeManage/SIndex.vue